export const NOTE_TYPE_LOG = 'log';
export const NOTE_TYPE_NOTE = 'note';
export const NOTE_TYPE_SERVICE_CALL_CHECK_IN = 'serviceCallCheckIn';
export const NOTE_TYPE_SERVICE_CALL_CHECK_OUT = 'serviceCallCheckOut';
export const NOTE_TYPE_USER = 'user';
